// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--stv-con-bo-str{
    width: 100%;
    min-height: 202px;
    display: flex;
    flex-direction: column;
    gap: 74px;
}

.scl-scbs-mai-ti-con-str{
    font-family: var(--primary-font);
    color: var(--color-text-third);
    font-size: var(--font-size-body-sm)
}

.scl-scbs-mai-ti-con-str span{
    padding-left: 5px;
    padding-right: 5px;
}

.scl--scbs-sec-ti-con-bo-str{
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{
    font-size: var(--font-size-sub-title-xl);
    color: var(--color-text-primary);
    font-family: var(--primary-font);
    font-weight: 500;
}

.scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{
    display: flex;
    align-items: center;
    width: 577px;
    color: var(--color-text-secondary);
    font-size: 20px;
    font-family: var(--primary-font);
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/title/section/css/sectionTitleView.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gCAAgC;AACpC","sourcesContent":[".scl--stv-con-bo-str{\n    width: 100%;\n    min-height: 202px;\n    display: flex;\n    flex-direction: column;\n    gap: 74px;\n}\n\n.scl-scbs-mai-ti-con-str{\n    font-family: var(--primary-font);\n    color: var(--color-text-third);\n    font-size: var(--font-size-body-sm)\n}\n\n.scl-scbs-mai-ti-con-str span{\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.scl--scbs-sec-ti-con-bo-str{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.scl--scbs-sec-ti-con-bo-str .scl--sstcbs-ti-str{\n    font-size: var(--font-size-sub-title-xl);\n    color: var(--color-text-primary);\n    font-family: var(--primary-font);\n    font-weight: 500;\n}\n\n.scl--scbs-sec-ti-con-bo-str .sc--sstcbs-pa-str{\n    display: flex;\n    align-items: center;\n    width: 577px;\n    color: var(--color-text-secondary);\n    font-size: 20px;\n    font-family: var(--primary-font);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
